import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SpinnerGap, WarningCircle, GoogleLogo } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace("#", ""));
        let sessionId = params.get("session_id");
        if (!sessionId) {
          sessionId = new URLSearchParams(window.location.search).get("session_id");
        }

        if (!sessionId) {
          navigate("/login", { replace: true });
          return;
        }

        // Exchange session_id for tokens (with timeout guard)
        const { data } = await axios.post(
          `${API}/auth/google-session`,
          { session_id: sessionId },
          { timeout: 45000 }
        );

        if (data.access_token) {
          localStorage.setItem("access_token", data.access_token);
        }
        if (data.refresh_token) {
          localStorage.setItem("refresh_token", data.refresh_token);
        }
        axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;

        window.history.replaceState(null, "", window.location.pathname);
        window.location.href = "/";
      } catch (err) {
        console.error("Google auth callback error:", err);
        const detail = err.response?.data?.detail;
        setError(
          typeof detail === "string"
            ? detail
            : "Não foi possível concluir o login com o Google. Sua conta NÃO foi perdida — tente novamente."
        );
        window.history.replaceState(null, "", window.location.pathname);
      }
    };

    processCallback();
  }, [navigate]);

  const retryGoogle = () => {
    const redirectUrl = `${window.location.origin}/`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 px-4">
        <div className="w-full max-w-md bg-white rounded-sm border border-zinc-200 shadow-sm p-8 text-center" data-testid="google-callback-error">
          <WarningCircle size={40} className="text-amber-500 mx-auto mb-3" weight="fill" />
          <h2 className="text-lg font-bold text-zinc-950 mb-2">Falha no login com Google</h2>
          <p className="text-sm text-zinc-500 mb-6">{error}</p>
          <button
            onClick={retryGoogle}
            data-testid="google-retry-btn"
            className="w-full flex items-center justify-center gap-2 bg-zinc-950 text-white rounded-sm py-2.5 text-sm font-bold hover:bg-zinc-800 transition-colors"
          >
            <GoogleLogo size={16} weight="bold" /> Tentar novamente com Google
          </button>
          <button
            onClick={() => navigate("/login", { replace: true })}
            data-testid="google-back-login-btn"
            className="w-full mt-2 text-sm text-zinc-500 hover:text-zinc-950 py-2"
          >
            Voltar ao login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="text-center">
        <SpinnerGap size={32} className="animate-spin text-zinc-400 mx-auto mb-3" />
        <p className="text-sm text-zinc-500">Autenticando com Google...</p>
      </div>
    </div>
  );
}
